import {SafeZoneSize, AppViewportConfig} from '@gongxigames/framework/core/services/screenManager/types';
import {ScreenOrientation} from '@gongxigames/framework/core/types';
import {ScreenParameters} from '@gongxigames/framework/core/fragments/ScreenParameters';

export class ViewportCalculator {
    private _screenParams!: ScreenParameters;

    constructor(private readonly _config: AppViewportConfig) {}

    public update(canvasWidth: number, canvasHeight: number): void {
        const orientation = this.getOrientation(canvasWidth, canvasHeight);
        const safeZone = this.getSafeZoneSize(orientation)!;
        const scale = Math.min(canvasWidth / safeZone.width, canvasHeight / safeZone.height);
        const x = (canvasWidth - safeZone.width * scale ) * 0.5;
        const y = (canvasHeight - safeZone.height * scale) * 0.5;

        this._screenParams = new ScreenParameters(
            orientation,
            canvasWidth, canvasHeight,
            safeZone.width, safeZone.height,
            scale, x, y
        );
    }

    public getScreenState(): ScreenParameters {
        return this._screenParams;
    }

    private getSafeZoneSize(orientation: ScreenOrientation): SafeZoneSize|undefined {
        return this._config.safeZone[orientation];
    }

    private getOrientation(width: number, height: number): ScreenOrientation {
        if (this._config.forceOrientation !== undefined) {
            return this._config.forceOrientation;
        }

        if (
            !this.getSafeZoneSize(ScreenOrientation.PORTRAIT) || // DeviceType.DESKTOP
            (height <= width)
        ) {
            return ScreenOrientation.LANDSCAPE;
        }

        return ScreenOrientation.PORTRAIT;
    }
}
